/** @jsx jsx */
import { Checkbox, jsx, Label, Stack, StackProps } from '@front10/base-elements';

import { useState } from 'react';

interface Props {
  defaultValue: boolean;
  label: string;
  name: string;
  onChange?: (newValues: boolean) => void;
}

export function CustomCheckbox({
  onChange,
  label,
  name,
  defaultValue,
  ...props
}: Props & Omit<StackProps, 'children' | 'ref' | 'onChange' | 'defaultValue'>) {
  const [state, setState] = useState(defaultValue);

  return (
    <Stack {...props}>
      <Label
        variant="text.fontSize5"
        sx={{
          color: 'text',
          width: 'unset',
          display: 'inline-flex',
          alignItems: 'center',
          'input:focus-within ~ svg,input:hover ~ svg,input:focus-visible ~ svg': {
            outline: '2px solid',
            outlineColor: 'secondary',
            outlineOffset: '-1px',
            variant: 'forms.checkbox'
          }
        }}
      >
        <Checkbox
          defaultChecked={defaultValue}
          key={name}
          onChange={() => {
            setState(!state);
            onChange?.(!state);
          }}
        />
        {label}
      </Label>
    </Stack>
  );
}
